import { doctrineAnalytics } from '../../utils/analyticsUtils';

export function sendNotificationClickedEvent() {
  doctrineAnalytics('Notification ItemClicked');
}
